import * as actionTypes from "./actionTypes";

export const getIssuerAccountsStart = () => {
  return {
    type: actionTypes.GET_ISSUER_ACCOUNTS_START,
  };
};

export const getIssuerAccountsFail = (error) => {
  return {
    type: actionTypes.GET_ISSUER_ACCOUNTS_FAIL,
    error,
  };
};

export const getIssuerAccounts = (search, pageLimit, page) => {
  return {
    type: actionTypes.GET_ISSUER_ACCOUNTS,
    search,
    pageLimit,
    page,
  };
};

export const getIssuerAccountsSuccess = (response) => {
  return {
    type: actionTypes.GET_ISSUER_ACCOUNTS_SUCCESS,
    response,
  };
};

export const getIssuerAccount = (id) => {
  return {
    type: actionTypes.GET_ISSUER_ACCOUNT,
    id,
  };
};

export const getIssuerAccountSuccess = (response) => {
  return {
    type: actionTypes.GET_ISSUER_ACCOUNT_SUCCESS,
    response,
  };
};

export const issuerAccountAction = (accData) => {
  return {
    type: actionTypes.ISSUER_ACCOUNT_ACTION,
    accData,
  };
};

export const issuerAccountActionResponse = (response) => {
  return {
    type: actionTypes.ISSUER_ACCOUNT_ACTION_RESPONSE,
    response,
  };
};
